export default __webpack_public_path__ + "static/media/nut-icon.8c0876b4.svg";